module.exports = __webpack_public_path__ + "static/img/analysis2.066982b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/analysis2.png
// module id = 7s/B
// module chunks = 1